import { detectMedia } from "./detect-media.js";
function getMediaSource(mediaUri, settings) {
  var _a, _b;
  const mediaListItem = (_b = (_a = settings == null ? void 0 : settings.mediaList) == null ? void 0 : _a.items) == null ? void 0 : _b.find((item) => item.uri === mediaUri);
  const detected = detectMedia(mediaUri);
  if (mediaListItem != null && "provider" in mediaListItem && (mediaListItem == null ? void 0 : mediaListItem.provider) != null) {
    return {
      ...mediaListItem,
      ...detected
    };
  }
  return detected;
}
export {
  getMediaSource
};
